import { uploadItems } from './UploadStore';

export const updateUploadItems = (value) => uploadItems.update((oldValue) => value);
